<template>
  <v-card color class="rounded-card">
    <form-container>
      <v-flex xs12 class="flex-container-space-between">
        <div>
          <v-icon
            large
            class="mr-2"
            :color="$store.state.global.pages.docket.color"
          >{{$store.state.global.pages.docket.icon}}</v-icon>
          <span class="headline">
            Docket
            <span
              class="grey--text subheading"
            >- {{`${docket.externalRef} (${docket.id})` || docket.id}}</span>
          </span>
        </div>
        <div class="vertical-center-container">
          <v-tooltip
            top
            v-if="userAuthClass && !trip.rctiId && !trip.billId && trip.docket.type=='DOCKET'"
          >
            <v-btn slot="activator" icon flat color="grey" @click="$emit('showAddTrip')">
              <v-icon>add</v-icon>
            </v-btn>Add a Trip to this Docket
          </v-tooltip>
          <v-tooltip top v-if="userAuthClass && !trip.rctiId && !trip.billId">
            <v-btn slot="activator" icon flat color="grey" @click="$emit('showEditDocket')">
              <v-icon>edit</v-icon>
            </v-btn>Edit this Docket
          </v-tooltip>
        </div>
      </v-flex>
      <card-divider-header></card-divider-header>
      <flex-sub-header>
        <div class="flex-container-space-between">
          <div>{{docket.site.project.name}} - {{docket.site.name}}</div>
          <div>{{makeLongDate(docket.date)}} ({{docket.billingPeriod}})</div>
        </div>
      </flex-sub-header>

      <v-flex xs12 class>
        <div class="flex-container-space-between">
          <div>
            <div class="vertical-center-container">
              <div
                class="grey--text text--darken-1 body-2"
              >{{`${docket.vehicle.name} (${docket.vehicle.vehicleType.name})`}} / {{ docket.driver.name}}</div>
            </div>
            <div class="grey--text">{{docket.vehicle.contractor.name}}</div>
          </div>
          <div>
            <div
              v-if="!!docket.totalTravel"
              class="text-xs-right grey--text"
            >Travel: {{docket.totalTravel}}</div>
            <div
              v-if="!!docket.totalBreaks"
              class="text-xs-right grey--text"
            >Breaks: {{docket.totalBreaks}}</div>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 class v-if="!!docket.notes">
        <div class="flex-container-space-between">{{docket.notes}}</div>
      </v-flex>
      <card-divider-header></card-divider-header>

      <!-- COST / SELL -->
      <flex-sub-header v-if="!!costTotal">
        <div class="flex-container-space-between">
          <div>Cost Total</div>
          <div class="grey--text body-1">${{parseFloat(costTotal).toFixed(2)}}</div>
        </div>
      </flex-sub-header>
      <flex-sub-header v-if="!!sellTotal">
        <div class="flex-container-space-between">
          <div>Sell Total</div>
          <div class="grey--text body-1">${{parseFloat(sellTotal).toFixed(2)}}</div>
        </div>
      </flex-sub-header>
      <card-divider-header v-if="!!costTotal || !!sellTotal"></card-divider-header>
      <!-- END COST / SELL -->

      <v-flex>
        <v-data-table :items="trips" :headers="headers" :rows-per-page-items="pageOptions">
          <template slot="items" slot-scope="props">
            <tr style="cursor: pointer" @click="$emit('showTripFromDocket',props.item.id)">
              <td class="text-xs-left">{{ props.item.spoil.name }}</td>
              <td class="text-xs-left">{{ props.item.tip.name }}</td>
              <td class="text-xs-right">{{ !!props.item.hours ? props.item.hours.toFixed(1) : '-' }}</td>
              <td
                class="text-xs-right"
              >{{ !!props.item.siteWeight ? props.item.siteWeight.toFixed(2) : '-' }}</td>
              <td
                class="text-xs-right"
              >{{ !!props.item.costTotal ? `$ ${parseFloat(props.item.costTotal).toFixed(2)}` : '-' }}</td>
              <td
                class="text-xs-right"
              >{{ !!props.item.sellTotal ? `$ ${parseFloat(props.item.sellTotal).toFixed(2)}` : '-' }}</td>
            </tr>
          </template>
        </v-data-table>
        <card-divider-full></card-divider-full>
        <div class="flex-container-space-between pt-2 pb-3">
          <div class="grey--text">Entered by: {{docket.createdBy.name}}</div>
          <div>
            <!-- <v-badge color="blue darken-4" right>
                                <span slot="badge">
                                    {{trips.length}}
                                </span>
                                <span class="body-2 grey--text text--darken-1">Total Trips</span>
            </v-badge>-->
            <v-badge overlap color="blue darken-4">
              <template slot="badge">{{trips.length}}</template>
              <v-icon large color="grey darken-1">{{$store.state.global.pages.docket.icon}}</v-icon>
            </v-badge>
            <!-- <div class="body-2 grey--text text--darken-1">
                                <span> Total Trips </span>
                                <v-badge color="blue darken-4" left>
                                    <span slot="badge">
                                        {{trips.length}}
                                    </span>
                                </v-badge>
            </div>-->
          </div>
        </div>
      </v-flex>
    </form-container>
  </v-card>
</template>

<script>
import FormatDates from '@/services/mixins/formatDates'
import CalculateTotal from '@/services/mixins/calculateTotal'

import DocketService from '@/services/requests/docketService'
import RowInfoDisplay from '@/components/ui/rowInfoDisplay'
export default {
  mixins: [FormatDates, CalculateTotal],
  data() {
    return {
      headers: [
        {
          text: 'Spoil',
          align: 'left',
          value: 'spoil.id'
        },
        {
          text: 'Tip',
          align: 'left',
          value: 'tip.id'
        },
        {
          text: 'Billable Hours',
          align: 'right',
          value: 'hours'
        },
        {
          text: 'Tip / WB Weight',
          align: 'right',
          value: 'siteWeight'
        },
        {
          text: 'Cost Total',
          align: 'right',
          value: 'costTotal'
        },
        {
          text: 'Sell Total',
          align: 'right',
          value: 'sellTotal'
        }
      ],
      pageOptions: [
        20,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
      ],
      options: [
        {
          title: 'Edit',
          icon: 'edit',
          method: () => {
            this.editDocketDialog = true
          }
        },
        {
          title: 'Archive',
          icon: 'book',
          method: () => {
            this.editDocketDialog = true
          }
        },
        {
          title: 'Delete',
          icon: 'delete',
          method: () => {
            this.editDocketDialog = true
          }
        }
      ],
      editDocketDialog: false,
      editTripDialog: false
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    getHoursFromDates(start, end) {
      var hours = 0
      var minutes = 0
      var startDateTime = new Date('01/01/2019 ' + start)
      var endDateTime = new Date('01/01/2019 ' + end)
      if (start && end) {
        hours = (endDateTime - startDateTime) / 1000 / 60 / 60
      }
      return hours.toFixed(2)
    }
  },
  asyncComputed: {
    trips: {
      async get() {
        var docketId = this.docket.id
        return DocketService.getTripsByDocket(docketId)
          .then(res => {
            //console.log(res.data);
            return res.data.result
          })
          .catch(err => {
            //console.log("An error occured");
            return ['error']
          })
      },
      default: []
    },
    async costTotal() {
      var total = 0
      if (this.userShowCost)
        total = await this.calculateTotal(this.trips, 'costTotal')
      return total
    },
    async sellTotal() {
      var total = 0
      if (this.userShowSell)
        total = await this.calculateTotal(this.trips, 'sellTotal')
      return total
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  props: {
    docket: Object,
    trip: Object,
    value: Boolean
  },
  watch: {
    //WATCH WHETHER DIALOG IS CLOSED AND SET EDITABLE TO FALSE IF IT CLOSES
    value(val) {
      !!val && (this.editDocketDialog = false)
    }
  },
  components: {
    RowInfoDisplay
  }
}
</script>

<style scoped>
.rounded-card {
  border-radius: 10px;
}
</style>
